import { useState, useEffect } from 'react';
import { EventCategory } from '../types/event';
import { categoryAPI } from '../services/categoryAPI';
import { logError } from '../utils/errorLogger';

interface UseCategoriesReturn {
  categories: EventCategory[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useCategories = (): UseCategoriesReturn => {
  const [categories, setCategories] = useState<EventCategory[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await categoryAPI.getCategories();
      setCategories(data);
    } catch (err: any) {
      logError('Error fetching categories', err);
      setError(err.response?.data?.message || err.message || 'Failed to fetch categories');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return {
    categories,
    loading,
    error,
    refetch: fetchCategories,
  };
};

export default useCategories;
